import { Component, OnInit } from '@angular/core';
import { AuthAndACLService } from '../../auth_and_acl/authAndACL.service';
import { Usuario } from './../../usuario/usuario';

import { URL_API } from './../../constante';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html'
})

export class MenuComponent implements OnInit {
    titulo_app = "SCD";
    public usuario: Usuario;
    manualurl: string;

    //TODO Melhorar a permissão do menu
    constructor(public authAndACL: AuthAndACLService) { 
      this.manualurl = URL_API + "/manual/manual-scd.pdf";
    }

    logout(): void {
      this.authAndACL.logout();
    }

    ngOnInit() {
      if (this.authAndACL.logado())  this.usuario = new Usuario();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/menu/menu.component.ts